module.exports = __webpack_public_path__ + "img/fan_fanset.c69f4e1a.svg";